import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("su_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

// Pages already visited show instantly from memory, then the copy is refreshed in the background.
const TTL = 60_000;
const VOLATILE = /\/(admin|auth|jobs|exam|final-exam|progress|messages|support|notifications|checkout|payments|resume|placement)(\/|$|\?)/;
const cache = new Map();
const rawGet = api.get.bind(api);
const keyOf = (url, cfg) => `${localStorage.getItem("su_token") || ""}|${url}|${JSON.stringify(cfg?.params || {})}`;

api.get = (url, cfg) => {
    if (VOLATILE.test(url) || cfg?.responseType) return rawGet(url, cfg);
    const key = keyOf(url, cfg);
    const hit = cache.get(key);
    const fetchFresh = () => rawGet(url, cfg).then((r) => { cache.set(key, { at: Date.now(), res: r }); return r; });
    if (hit && Date.now() - hit.at < TTL) {
        fetchFresh().catch(() => {});
        return Promise.resolve(hit.res);
    }
    return fetchFresh();
};

export const clearApiCache = () => cache.clear();
api.interceptors.response.use((r) => {
    if (r.config?.method && r.config.method !== "get") cache.clear();
    return r;
}, (err) => {
    // Arabic courses are closed until the mandatory level test is done.
    if (err?.response?.status === 428 && err.response.data?.detail === "placement_required" && !window.location.pathname.includes("test-de-niveau")) {
        window.location.assign("/arabe-coranique/test-de-niveau");
    }
    return Promise.reject(err);
});

export default api;

export function fileDownloadUrl(fileId) {
    const token = localStorage.getItem("su_token");
    const q = token ? `?auth=${encodeURIComponent(token)}` : "";
    return `${API}/files/${fileId}/download${q}`;
}
